import apiHeader from '@/helpers/apiHeader';

const catalogTypesService = {
    list(params) {
        return apiHeader.get('general-master-data/catalog-type', { params });
    },
};

export default catalogTypesService;
